<template>
  <v-card :loading="loading" :disable="loading">
    <CardTitle title="Hubspot Contacts">
      <template v-slot:prepend_actions>
        <v-icon color="orange" large>mdi-hubspot</v-icon>
      </template>
      <template v-slot:actions>
        <slot name="title_actions"></slot>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
          </template>
          <span>Reload Data</span>
        </v-tooltip>
      </template>
    </CardTitle>
    <v-card-text>
      <v-data-table
          :headers="table_headers"
          :items="contacts"
          sort-by="firstname"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Hubspot from "@/Lib/Hubspot";

export default {
    name: "HubspotContacts",
    components: {},
    props:{
      hubspot_id:{
        required: true,
      }
    },
    data: () => ({
      loading: false,
      table_headers:[
        {text: "First Name", value: "firstname"},
        {text: "Last Name", value: "lastname"},
        {text: "Email", value: "email"}
      ],
      contacts: [],
    }),
    watch:{
      hubspot_id(){
        if(!this.loading){
          this.loadData();
        }
      }
    },
    mounted(){
      if(!this.loading){
        this.loadData();
      }
    },
    methods: {
      async loadData(){
        this.loading = true;
        try{
          let contacts = await Hubspot.post('/contacts/search', {
            filters: [{
              propertyName: "associations.company",
              operator: "EQ",
              value: this.hubspot_id
            }]
          })
          this.contacts = contacts.data.results.map(contact => {
            return {
              id: contact.id,
              ...contact.properties
            }
          });
        }catch(e){
          console.log(e);
        }finally{
          this.loading = false;
        }
      }
    }
}
</script>

<style scoped>

</style>